const toastedPlugin = {
  install (Vue, options) {
    Vue.prototype.$toastedPush = (value) => {
      let iconfa = ''
      switch (value.type) {
        case 'success':
          iconfa = Vue.icon(Vue.fa.faCheck).html
          break
        case 'info':
          iconfa = Vue.icon(Vue.fa.faInfoCircle).html
          break
        case 'error':
          iconfa = Vue.icon(Vue.fa.faExclamationTriangle).html
          break
        default:
          iconfa = Vue.icon(Vue.fa.faCheck).html
          break
      }
      Vue.toasted.show(`${iconfa}&nbsp;${value.message} `, {
        position: 'bottom-right',
        duration: value.duration || 5000,
        type: value.type,
        action: value.action,
        ...value.options
      })
    }
  }
}

export default toastedPlugin
